'use strict';
module.exports = function (val) {
	return val < 0 ? Math.ceil(val) : Math.floor(val);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-trunc/index.js
// module id = 2209
// module chunks = 204